import React from 'react';

import { AllLogos } from '../components/logos/AllLogos';

export function About(){
  return (
    <div style={{ textAlign: 'left' }}>
      <h1>About Me</h1>
      <p>
        At Home Right Massage..... Massage Therapy comes to you.
      </p> 
      <p>
        Whether at home or at the office, let Michael relieve any pain or 
        discomfort that you may be living with. 
        From tension to post-surgical treatments, there is a massage therapy for you.
      </p>
      <p>
        Michael has been practicing massage therapy since 2017. 
        After graduating from Swedish Institute, he worked as an LMT at the 
        Swedish Institute Clinic and became the MT department manager at a 
        physical therapy and chiropractic practice in Manhattan. 
        In 2022, he decided it was time to bring massage therapy to folks in their own home. 
      </p>
      <p>
        Nicknamed "the fluid nerd" in college, Michael believes that fluid movement, 
        circulation and replenishment are key to our quality of life. Hydrate, Hydrate, Hydrate!
      </p>
      <AllLogos />
    </div>
  );
}
